// Offer Wall Ad
export const GET_OFFER_WALL_AD = 'GET_OFFER_WALL_AD';
export const UPDATE_OFFER_WALL_AD = 'UPDATE_OFFER_WALL_AD';
export const UPDATE_OFFER_WALL_AD_ERROR = 'UPDATE_OFFER_WALL_AD_ERROR';
export const CREATE_OFFER_WALL_AD = 'CREATE_OFFER_WALL_AD';
export const GET_OFFER_WALL_ADS = 'GET_OFFER_WALL_ADS';
